var format = {
  /**
   * Add commas and decimal places to a number
   * @param  {Number} number   The number to format
   * @param  {Number} decimals The decimal significance
   * @return {string}          The formatted number
   */
  number: function(number, decimals) {
    var out = [];

    // set to fixed number of decimals if  need be
    if(typeof decimals !== 'undefined') {
      number = number.toFixed(decimals);
    }

    // split whole numbers and decimals
    number = number.toString().split('.');

    // add commas
    out.push(number[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));

    // output
    if(number.length === 1) {
      return '' + out[0];
    } else {
      return '' + out[0] + '.' + number[1];
    }
  },

  /**
   * Makes long numbers shorter
   * @param  {Number} number    The number to format
   * @param  {Number} decimals  The decimal significance
   * @param  {Number} threshold The threshold significance
   * @return {string}           The formatted number
   */
  niceNumber: function(number, decimals, threshold) {
    number = parseInt(number);

    // default 0 decimal
    if(typeof decimals === 'undefined') {
      decimals = 0;
    }

    // default threshold 9999
    if(typeof threshold === 'undefined') {
      threshold = 10000;
    }

    if(number < threshold || threshold === -1) {
      return this.number(number);
    } else if(number < 1000000) {
      return this.number(number / 1000, decimals) + 'k';
    } else {
      return this.number(number / 1000000, decimals) + 'm';
    }
  }
}

window.avFormat = format;